

  function initSwiper(q) {
    // Tikriname, ar Swiper biblioteka yra pasiekiama
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library is not loaded.');
      return;
    }

    const swiper = new Swiper(q, {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
               autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 30,
               autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
        },
      },
    });
  }

initSwiper('.swiper-container');